"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CollectionUtility = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _functional_utility = require("./functional_utility");

var _ramda = require("ramda");

var _string_utility = require("./string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectionUtility = exports.CollectionUtility = {
    map: function map(collection, predicate) {
        if ((0, _functional_utility.isNilOrEmpty)(collection)) {
            return [];
        }

        return (0, _ramda.addIndex)(_ramda.map)(predicate, collection);
    },
    includes: function includes(collection, value) {
        if ((0, _functional_utility.isNilOrEmpty)(collection)) {
            return false;
        }

        return (0, _ramda.includes)(value, collection);
    },
    reduce: function reduce(collection, predicate, acc) {
        if ((0, _functional_utility.isNilOrEmpty)(collection)) {
            return [];
        }

        return (0, _ramda.reduce)(predicate, acc, collection);
    },
    forEachIndexed: function forEachIndexed(collection, predicate) {

        if ((0, _functional_utility.isNilOrEmpty)(collection)) {
            return [];
        }

        if (this.isObject(collection)) {
            return (0, _ramda.forEachObjIndexed)(predicate, collection);
        }

        return (0, _ramda.addIndex)(_ramda.forEach)(predicate, collection);
    },
    isArray: function isArray(collection) {
        return Array.isArray(collection);
    },
    filter: function filter(collection, predicate) {
        if ((0, _functional_utility.isNilOrEmpty)(collection)) {
            return [];
        }

        return (0, _ramda.addIndex)(_ramda.filter)(predicate, collection);
    },
    merge: function merge() {
        var collection = [].concat(Array.prototype.slice.call(arguments));

        if ((0, _functional_utility.isNilOrEmpty)(collection)) {
            return {};
        }

        return (0, _ramda.mergeAll)(collection);
    },
    clone: function clone(obj) {
        return (0, _ramda.clone)(obj);
    },
    isObject: function isObject(collection) {
        return !this.isArray(collection) && (typeof collection === "undefined" ? "undefined" : _typeof(collection)) === "object" && !(0, _ramda.isNil)(collection);
    },
    size: function size(collection) {
        if ((0, _functional_utility.isNilOrEmpty)(collection)) {
            return 0;
        }

        if (this.isObject(collection)) {
            return (0, _ramda.length)((0, _ramda.keys)(collection));
        }

        return (0, _ramda.length)(collection);
    },
    find: function find(collection, predicate) {
        if ((0, _functional_utility.isNilOrEmpty)(collection)) {
            return null;
        }

        return (0, _ramda.find)(predicate, collection);
    },
    intersection: function intersection(arr1, arr2) {
        return (0, _ramda.intersection)((0, _ramda.isNil)(arr1) ? [] : arr1, (0, _ramda.isNil)(arr2) ? [] : arr2);
    },
    intersectionKebabCase: function intersectionKebabCase(arr1, arr2) {
        var arr2Upper = (arr2 || []).map(function (e) {
            return _string_utility2.default.customKebabCase(e);
        });
        return (arr1 || []).filter(function (x) {
            return arr2Upper.includes(_string_utility2.default.customKebabCase(x));
        });
    },
    sort: function sort(collection, sortProp, sortOrder) {
        var sortFn = sortOrder === 'asc' ? _ramda.ascend : _ramda.descend;
        return (0, _ramda.sortWith)([sortFn((0, _ramda.prop)(sortProp))])(collection);
    },
    sortWithChineseStroke: function sortWithChineseStroke(list, locale) {
        return list.sort(new Intl.Collator(locale, { collation: 'stroke' }).compare);
    },
    getValueFromArr: function getValueFromArr(arr, index, attr) {
        if (arr.length > index) {
            return arr[index][attr];
        }
    }
};